<header class="header header-nav-menu">
    <div class="logo-container">


        <!-- end: header nav menu -->
        <!-- start: search & user box -->
        <!-- <button class="btn header-btn-collapse-nav d-lg-none" data-bs-toggle="collapse" data-bs-target=".header-nav">
            <i class="fas fa-bars"></i>
        </button> -->

        <nav class="navbar navbar-expand-lg bg-body-tertiary prosol-nav">
            <a routerLink="/homeindex" class="logo navbar-brand">
                <img src="./assets/prosol-logo.svg" height="40" alt="PROSOL" />
            </a>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <i class="fas fa-bars white" aria-label="Toggle sidebar"></i>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">

                    <li class="nav-item dropdown" routerLinkActive="active-link">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="./assets/users.svg" height="16" alt="PROSOL" />
                            <span> User Master</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li *ngFor="let item of common.Users">
                                <a [routerLink]="item.Link" class="dropdown-item" routerLinkActive="active-link">
                                    {{ item.Name }}
                                </a>
                            </li>
                        </ul>
                    </li>

                    <!-- ===== Mega Menu Item ===== -->
                    <li class="nav-item dropdown dropdown-mega materialmenu" routerLinkActive="active-link"
                        *ngIf="common.Material.length > 0">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="./assets/material-master-icon.svg" height="16" alt="PROSOL" />
                            <span> Material Master</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i> </a>


                        <div class="dropdown-menu">
                            <div class="container">
                                <div class="mega-row">
                                    <div class="mega-col column">
                                        <ul class="list-unstyled">

                                            <li *ngFor="let item of common.Material">
                                                <a [routerLink]="item.Link" class="dropdown-item"
                                                    routerLinkActive="active-link">{{ item.Name }}</a>
                                            </li>
                                            <li>
                                                <a href="./assets/Material-Master-Workflow.svg" target="_blank"
                                                    class="dropdown-item">Workflow</a>
                                            </li>
                                            <li>
                                                <a href="#" (click)="onHealthCheckClick($event)" class="dropdown-item">Health check</a>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item dropdown" routerLinkActive="active-link" *ngIf="common.Service.length > 0">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="./assets/service-master-icon.svg" height="16" alt="PROSOL" />
                            <span> Service Master</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li *ngFor="let item of common.Service">
                                <a [routerLink]="item.Link" class="dropdown-item" routerLinkActive="active-link">
                                    {{ item.Name }}
                                </a>
                            </li>
                            <li>
                                <a href="./assets/Service.png" target="_blank" class="dropdown-item">Workflow</a>
                            </li>

                        </ul>
                    </li>

                    <!-- ===== Mega Menu Item ===== -->
                    <li class="nav-item dropdown dropdown-mega materialmenu" routerLinkActive="active-link"
                        *ngIf="common.Vendor?.length > 0 || common.Customer?.length > 0">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="./assets/business-partner-icon.svg" height="16" />
                            <span> Business Partner</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i> </a>


                        <div class="dropdown-menu">
                            <div class="container">
                                <div class="mega-row">
                                    <div class="mega-col column">
                                        <ul class="list-unstyled">
                                            <li *ngFor="let item of common.Vendor">
                                                <a [routerLink]="item.Link" class="dropdown-item"
                                                    routerLinkActive="active-link">
                                                    {{ item.Name }}
                                                </a>
                                            </li>
                                             <li>
                                                <a href="./assets/Vendor-master-workflow.svg" target="_blank"
                                                    class="dropdown-item">Vendor Workflow</a>
                                            </li>
                                            <li *ngFor="let item of common.Customer">
                                                <a [routerLink]="item.Link" class="dropdown-item"
                                                    routerLinkActive="active-link">
                                                    {{ item.Name }}
                                                </a>
                                            </li>
                                             <li>
                                                <a href="./assets/Customer-master-workflow.svg" target="_blank"
                                                    class="dropdown-item">Customer Workflow</a>
                                            </li>
                                        </ul>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- <li class="nav-item dropdown dropdown-mega materialmenu" routerLinkActive="active-link">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="./assets/asset-master-icon.svg" height="16" alt="PROSOL" />
                            <span> Financial Master</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i> </a>


                        <div class="dropdown-menu">
                            <div class="container">
                                <div class="mega-row">
                                    <div class="mega-col column">
                                        <ul class="list-unstyled">
                                            <li>
                                                <a routerLinkActive="active-link" class="dropdown-item"
                                                    routerLink="/company-code-requester">
                                                    Company Code
                                                </a>
                                            </li>

                                            <li>
                                                <a routerLinkActive="active-link" class="dropdown-item"
                                                    routerLink="/controlling-area">
                                                    Controlling Area
                                                </a>
                                            </li>
                                            <li>
                                                <a routerLinkActive="active-link" class="dropdown-item"
                                                    routerLink="/profit-center">
                                                    Profit Center
                                                </a>
                                            </li>
                                            <li>
                                                <a routerLinkActive="active-link" class="dropdown-item"
                                                    routerLink="/general-ledger-account">
                                                    General Ledger Account
                                                </a>
                                            </li>
                                            <li>
                                                <a routerLinkActive="active-link" class="dropdown-item" 
                                                routerLink="/cost-center">
                                                    Cost Center
                                                </a>
                                            </li>

                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </li> -->

                    <li class="nav-item dropdown dropdown-mega materialmenu" routerLinkActive="active-link"
                        *ngIf="common.Asset?.length > 0">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="./assets/asset-master-icon.svg" height="16" alt="PROSOL" />
                            <span> Asset Master</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i> </a>


                        <div class="dropdown-menu">
                            <div class="container">
                                <div class="mega-row">
                                    <div class="mega-col column">
                                        <ul class="list-unstyled">

                                            <li *ngFor="let item of common.Asset">
                                                <a [routerLink]="item.Link" routerLinkActive="active-link"
                                                    class="dropdown-item">
                                                    {{ item.Name }}
                                                </a>
                                            </li>
                                       

                                         
                                            <li>
                                                <a href="./assets/Asset-master-workflow.svg" target="_blank"
                                                    class="dropdown-item">Workflow</a>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item dropdown" routerLinkActive="active-link" *ngIf="common.BOM?.length > 0">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="./assets/BOM-icon-mobile.svg" height="16" alt="PROSOL" />
                            <span> BOM</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li *ngFor="let item of common.BOM">
                                <a [routerLink]="item.Link" class="dropdown-item" routerLinkActive="active-link">
                                    {{ item.Name }}
                                </a>
                            </li>
                            <li>
                                <a href="./assets/Customer.png" target="_blank" class="dropdown-item">Workflow</a>
                            </li>

                        </ul>
                    </li>
                    <li class="nav-item dropdown" routerLinkActive="active-link" *ngIf="common.Admin?.length > 0">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">

                            <img src="./assets/user.svg" height="16" alt="Users" />
                            <span> Admin</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i>
                        </a>
                        <ul class="dropdown-menu Adminmenu" aria-labelledby="navbarDropdownMenuLink">

                            <li>
                                <a class="dropdown-item">
                                    Material Master Tools &raquo;
                                </a>
                                <ul class="dropdown-menu dropdown-submenu">

                                    <li>
                                        <a class="dropdown-item">Meta Data &raquo; </a>
                                        <ul class="dropdown-menu dropdown-submenu">
                                            <li *ngFor="let item of common.MetaData" class="dropdown-item">
                                                <a [routerLink]="item.Link" class="nav-link"
                                                    routerLinkActive="active-link">
                                                    {{ item.Name }}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a class="dropdown-item">Lov Master &raquo; </a>
                                        <ul class="dropdown-menu dropdown-submenu">
                                            <li *ngFor="let item of common.LOV" class="dropdown-item">
                                                <a [routerLink]="item.Link" class="nav-link"
                                                    routerLinkActive="active-link">
                                                    {{ item.Name }}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a class="dropdown-item">Settings &raquo; </a>
                                        <ul class="dropdown-menu dropdown-submenu">
                                            <li *ngFor="let item of common.Settings" class="dropdown-item">
                                                <a [routerLink]="item.Link" class="nav-link"
                                                    routerLinkActive="active-link">
                                                    {{ item.Name }}
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li *ngFor="let item of common.Admin">
                                        <a [routerLink]="item.Link" class="dropdown-item"
                                            routerLinkActive="active-link">
                                            {{ item.Name }}
                                        </a>
                                    </li>

                                </ul>
                            </li>
                            <li *ngFor="let item of common.Tools">
                                <a [routerLink]="item.Link" class="dropdown-item" routerLinkActive="active-link">
                                    {{ item.Name }}
                                </a>
                            </li>

                        </ul>
                    </li>





                    <li class="nav-item dropdown" routerLinkActive="active-link"
                        *ngIf="common.Datacleasning?.length > 0">
                        <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <img src="./assets/Data Cleansing.svg" height="16" alt="PROSOL" />
                            <span> Data Cleansing</span>&nbsp;<i class="fa-classic fa-solid fa-caret-down"></i>
                        </a>
                        <ul class="dropdown-menu">
                            <li *ngFor="let item of common.Datacleasning">
                                <a [routerLink]="item.Link" class="dropdown-item" routerLinkActive="active-link">
                                    {{ item.Name }}
                                </a>
                            </li>

                        </ul>
                    </li>

                </ul>

            </div>
            <div class="header-right">

                <div id="userbox" class="userbox">
                    <a data-bs-toggle="dropdown" class="btn dropdown-toggle" type="button" aria-expanded="false">
                        <div class="profile-picture">
                            <img src="./assets/user.svg" height="16" alt="PROSOL" class="img-circle" />

                        </div>
                        <div class="profile-info">
                            <span class="name" style="font-size:var(--prosol-font-size);"> Welcome, &nbsp;
                                {{UserName}}</span> <i class="fa custom-caret"></i>



                        </div>
                        <div class="time-login"> <span class="role"
                                style="color: var(--prosol-text-color); font-size: var(--prosol-font-size);">Last Log
                                in:{{LastLogin}} </span></div>




                    </a>

                    <div class="dropdown" style="text-align: center;margin-top: -50px;z-index: 111;">

                        <ul class="dropdown-menu">
                            <li><a [routerLink]="'profile'" class="nav-link" routerLinkActive="active-link"><i
                                        class="fa fa-user"></i> My
                                    Profile</a></li>
                            <li><a routerLink="changepassword" class="nav-link" routerLinkActive="active-link"><i
                                        class="fa fa-key"></i> Change
                                    Password</a></li>
                            <li><a class="dropdown-item" routerLink="login" (click)="logout()"><i
                                        class="fa fa-power-off"></i> Logout</a></li>
                        </ul>
                    </div>
                </div>
            </div>

        </nav>


    </div>
</header>